import type { ArchitectureNode, ArchitectureEdge } from '../types';

export const architectureNodes: ArchitectureNode[] = [
  {
    id: 'security',
    label: 'SECURITY',
    simpleLabel: 'Безопасность',
    description: 'Проверяет, нет ли опасных или недопустимых запросов. Первый фильтр, который защищает и пользователя, и систему.',
    color: '#FF4D4D',
    x: -6,
    y: 2,
    z: 0,
  },
  {
    id: 'metrics',
    label: 'METRICS',
    simpleLabel: 'Метрики',
    description: 'Измеряет состояние диалога: ритм, доверие, боль, хаос и другие сигналы. Как нервная система Искры.',
    color: '#FF7A00',
    x: -4,
    y: 1,
    z: 0,
  },
  {
    id: 'slo-guard',
    label: 'SLO-GUARD',
    simpleLabel: 'Страж качества',
    description: 'Решает, можно ли продолжать, нужно ли снизить темп или закрыть тему честно.',
    color: '#FFB020',
    x: -2,
    y: 0,
    z: 0,
  },
  {
    id: 'playbook',
    label: 'PLAYBOOK',
    simpleLabel: 'Сценарий',
    description: 'Выбирает режим работы: обычный (ROUTINE), проверка фактов (SIFT), поддержка (SHADOW), совет (COUNCIL) или кризис (CRISIS).',
    color: '#4DA3FF',
    x: 0,
    y: 0,
    z: 0,
  },
  {
    id: 'council',
    label: 'COUNCIL',
    simpleLabel: 'Совет голосов',
    description: 'Арбитраж между девятью голосами Искры. Решает, кто из них лучше подходит к текущей ситуации.',
    color: '#9B59B6',
    x: 2,
    y: 0,
    z: 0,
  },
  {
    id: 'voice',
    label: 'VOICE',
    simpleLabel: 'Голос',
    description: 'Выбранная личность отвечает пользователю: мягко, жёстко, иронично или структурированно.',
    color: '#2ECC71',
    x: 4,
    y: 1,
    z: 0,
  },
  {
    id: 'speech',
    label: 'РЕЧЬ',
    simpleLabel: 'Речь',
    description: 'Финальная формулировка ответа с учётом ритма, температуры и глубины.',
    color: '#E6E8EB',
    x: 6,
    y: 2,
    z: 0,
  },
  {
    id: 'commit',
    label: 'COMMIT',
    simpleLabel: 'Шаг',
    description: 'Каждый важный диалог должен заканчиваться конкретным действием или артефактом. Без шага нет правды.',
    color: '#FF7A00',
    x: 8,
    y: 3,
    z: 0,
  },
];

export const architectureEdges: ArchitectureEdge[] = [
  { from: 'security', to: 'metrics' },
  { from: 'metrics', to: 'slo-guard' },
  { from: 'slo-guard', to: 'playbook' },
  { from: 'playbook', to: 'council' },
  { from: 'council', to: 'voice' },
  { from: 'voice', to: 'speech' },
  { from: 'speech', to: 'commit' },
];

export const techStack = [
  { name: 'React 19', role: 'Интерфейс' },
  { name: 'TypeScript 5.8', role: 'Типизация' },
  { name: 'Vite 6', role: 'Сборка' },
  { name: 'Supabase', role: 'База данных, auth, edge functions' },
  { name: 'Google Gemini', role: 'AI-модель через безопасный шлюз' },
  { name: 'GraphRAG', role: 'Память как граф знаний' },
];
